export default {
      id: "settings-profile-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#settings-profile-usage",
      toString: function () {
        return this.url;
      }
    }